module.exports = __webpack_public_path__ + "img/lt.47e993d8.svg";